import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { resolveImage } from "@/lib/api";
import { Leaf, ChevronLeft, ChevronRight } from "lucide-react";

export function ImageGallery({ images = [], alt = "", testid = "gallery" }) {
  const ordered = [...(images || [])].sort((a, b) => (b.is_primary ? 1 : 0) - (a.is_primary ? 1 : 0));
  const [open, setOpen] = useState(false);
  const [idx, setIdx] = useState(0);

  if (ordered.length === 0) {
    return (
      <div className="aspect-square flex items-center justify-center text-gray-300 rounded-sm border border-border bg-secondary" data-testid={`${testid}-empty`}>
        <Leaf strokeWidth={2} className="h-14 w-14" />
      </div>
    );
  }

  const openAt = (i) => { setIdx(i); setOpen(true); };
  const prev = (e) => { e?.stopPropagation(); setIdx((i) => (i - 1 + ordered.length) % ordered.length); };
  const next = (e) => { e?.stopPropagation(); setIdx((i) => (i + 1) % ordered.length); };

  return (
    <div data-testid={testid}>
      <button
        type="button"
        onClick={() => openAt(0)}
        data-testid={`${testid}-cover`}
        className="block w-full rounded-sm overflow-hidden border border-border bg-secondary group cursor-zoom-in"
      >
        <img src={resolveImage(ordered[0].image_url)} alt={alt} className="w-full max-h-[70vh] object-cover transition-transform duration-500 group-hover:scale-105" />
      </button>

      {ordered.length > 1 && (
        <div className="mt-3 flex gap-2 flex-wrap" data-testid={`${testid}-thumbs`}>
          {ordered.map((im, i) => (
            <button
              key={im.id || i}
              type="button"
              onClick={() => openAt(i)}
              data-testid={`${testid}-thumb-${i}`}
              className="h-16 w-16 rounded-sm overflow-hidden border border-border hover:border-sage transition-colors duration-200"
            >
              <img src={resolveImage(im.image_url)} alt="" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl p-0 bg-black/95 border-0 rounded-sm" data-testid={`${testid}-lightbox`}>
          <div className="relative flex items-center justify-center min-h-[55vh]">
            <img src={resolveImage(ordered[idx].image_url)} alt={alt} className="max-h-[85vh] w-auto object-contain" data-testid={`${testid}-lightbox-image`} />
            {ordered.length > 1 && (
              <>
                <button onClick={prev} data-testid={`${testid}-prev`} className="absolute left-3 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-white/15 hover:bg-white/30 text-white flex items-center justify-center transition-colors duration-200"><ChevronLeft className="h-5 w-5" /></button>
                <button onClick={next} data-testid={`${testid}-next`} className="absolute right-3 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-white/15 hover:bg-white/30 text-white flex items-center justify-center transition-colors duration-200"><ChevronRight className="h-5 w-5" /></button>
                <span className="absolute bottom-3 left-1/2 -translate-x-1/2 text-white/80 text-xs font-data">{idx + 1} / {ordered.length}</span>
              </>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
